<template>
  <div class="plan-card-premium-component
    w-full
    bg-[#DCEAFF]/90
    p-6
    text-black">
    <h3 class="text-sm
      font-semibold
      text-[#000000]
      text-center
      mt-4">{{$t('planCard.elevateYourDigitalSignage')}}</h3>

    <h1 class="text-3xl
      font-black
      text-[#000000]
      uppercase
      text-center
      mt-3">{{$t('planCard.premium')}}</h1>

    <h1 class="text-3xl
      font-black
      text-[#23569F]
      uppercase
      text-center
      mt-3">{{$t('planCard.premiumPlanPrice')}}</h1>

    <h3 class="text-sm
      font-semibold
      text-[#000000]
      text-center">{{$t('planCard.playerPerMonth')}}</h3>

    <ul class="main-features mt-[24px] w-[189px] mx-auto">
      <li v-for="(item, index) in mainFeatures" :key="index"
        class="p-3
          px-0
          border-b
          border-white
          last:border-b-0
          text-xs
          font-semibold
          text-left">{{item}}</li>
    </ul>

    <ul class="feature-details mt-10">
      <li v-for="(item, index) in featureDetails" :key="index"
        class="p-1 px-0 font-semibold">
          <div class="block text-left">
            <span class="p-[12px] bg-no-repeat bg-center bg-[url('@/static/icons/check_blue.svg')]"></span>
            <span class="ml-[4px] text-xs">{{item.label}}</span>

            <!-- NEW feature 12 Apps -->
            <span v-if="isFeatureTwelveApps(item)" class="text-[#F46D6D] uppercase text-xs ml-[4px]">{{$t('planCard.new')}}</span>

            <!-- NEW feature Video Wall -->
            <template v-if="isFeatureVideoWallSupport(item)">
              <span class="text-[#F46D6D] uppercase text-xs ml-[4px]">{{$t('planCard.new')}}</span>
              <span class="ml-[28px] inline-flex text-xs">
                {{$t('planCard.withTheNew')}}
                <a href="https://www.spinetix.com/digital-signage-products/players/ibx440" target="_blank" class="block ml-[3px] underline text-xs">iBX440</a>
              </span>
            </template>
          </div>
      </li>
    </ul>

      <div class="plan-actions mt-[40px] text-center">
        <el-button @click="$emit('get-premium-clicked')" class="get-premium-btn text-base">{{$t('planCard.getPremium')}}</el-button>
      </div>
  </div>
</template>

<script src="./plan-card-premium.js"></script>
<style lang="scss" src="./plan-card-premium.scss"></style>
